import { graphql } from 'gatsby';
import ResponsiveImage from '@/components/ResponsiveImage/ResponsiveImage';
import Video from '@/components/Video/Video';
import { Container, Wrapper } from './SingleMedia.styles';
import { applyPaddingCSS } from '@/utils/generatePadding';
import { type BlockHTMLId } from '@/utils/renderBlock';

const SingleMedia = ({
  singleMediaElements: elements,
  system,
  id,
}: Queries.SINGLE_MEDIAFragment & BlockHTMLId) => {
  const type = elements.media.value.__typename;

  return (
    <Container css={applyPaddingCSS(elements)} data-codename={system.codename} id={id}>
      <Wrapper columns={elements.width.value}>
        {type === 'kontent_item_responsive_image' && <ResponsiveImage {...elements.media.value} />}
        {type === 'kontent_item_video' && <Video {...elements.media.value} />}
      </Wrapper>
    </Container>
  );
};

export const fragment = graphql`
  fragment SINGLE_MEDIA on kontent_item_single_media {
    singleMediaElements: elements {
      ...COMPONENT_A_B_TEST
      ...PADDING
      media {
        value {
          __typename
          ...VIDEO
          ...RESPONSIVE_IMAGE
        }
      }
      width {
        value
      }
    }
    system {
      codename
      id
    }
  }
`;

export default SingleMedia;
